import axios from "axios";
import config from "../../../../configs/config";

export const postUserMessageToSlack = async ({ teamName, email, message, messageType }: PostUserMessageToSlackProps) => {
  try {
    const isSupportMessage = messageType === "support";
    const inputText = `${isSupportMessage ? `Hey <!here>, a support message has just been posted below:\n\n` : ""}` + `*${isSupportMessage ? "Support" : "Feedback"} Message*: ${message}\n` + `*Team*: ${teamName}\n` + `*Email*: ${email}\n` + `*Date & Time*: ${new Date().toLocaleString()}\n`;
    const inputChannel = config.slack[isSupportMessage ? "STUDIO_SUPPORT_CHANNEL" : "STUDIO_FEEDBACK_CHANNEL"];
    const response = await axios.get(`${config.slack.URL}/postMessage?inputText=${encodeURIComponent(inputText)}&inputChannel=${inputChannel}`);
    return response;
  } catch (error) {
    return error;
  }
};
